qw-extra-basket {
  display: flex;
  flex-direction: column;
  background: var(--qw-hotel-background);
}

qw-extra-basket qw-extra-card {
  display: grid;
  width: 100%;
  grid-template-columns: 30% 70%;
  grid-template-rows: 50% 50%;
}

qw-extra-basket qw-extra-card .qw-extra-card__image {
  grid-column: 1 / 2;
  grid-row: 1 / 3;
  padding-right: var(--qw-hotel-gap-sm);
}

qw-extra-basket qw-extra-card .qw-extra-card__content {
  width: 70%;
}

qw-extra-basket qw-extra-card .qw-extra-card__footer .qw-extra-card__quantity {
  order: -1;
}

.qw-extra-basket--basic qw-extra-card {
  grid-template-columns: 100%;
}
.qw-extra-basket--basic .qw-extra-card__title,
.qw-extra-basket--basic .qw-extra-card__footer {
  grid-column: 1 / 2;
}
.qw-extra-basket--basic .qw-extra-card__image,
.qw-extra-basket--basic .qw-extra-card__footer {
  display: none;
}
